import { useCallback } from 'react'
import { FormikErrors } from 'formik'
import {
  addOppFieldsToCheckNonRequiredErrors,
  useGetEntityFormDataOnMount,
} from '@user/components/Settings/EntityFormSettings'
import { IAddOpportunityFormModel } from '../../../typings'
import { ENTITY_TYPES } from '@sales-center/common'

export interface Props {
  setHideOptional: (status: boolean) => void
  errors: FormikErrors<IAddOpportunityFormModel>
  values: IAddOpportunityFormModel
}

export const useNonRequiredFieldValidate = (props: Props) => {
  const { setHideOptional, errors } = props

  const { entitySettingsMap, customFieldSettings } =
    useGetEntityFormDataOnMount(ENTITY_TYPES.Opportunity)

  const checkNonRequiredErrors = useCallback(() => {
    let nonRequiredHasErrors = false

    addOppFieldsToCheckNonRequiredErrors.forEach((field) => {
      const [isRequired, hasEnabled] = entitySettingsMap.get(field.name) ?? [
        false,
        false,
      ]
      const fieldErrors = field.errorFields.filter(
        (errorField) => errors[errorField] !== undefined,
      )

      if (!isRequired && hasEnabled && fieldErrors.length > 0) {
        nonRequiredHasErrors = true
      }
    })

    customFieldSettings.map((cs) => {
      if (!cs.required && cs.enabled) {
        for (const field in errors.customFields?.number) {
          if (field === cs.customFieldId.toString()) nonRequiredHasErrors = true
        }
      }
    })

    if (nonRequiredHasErrors) setHideOptional(!nonRequiredHasErrors)

    return nonRequiredHasErrors
  }, [setHideOptional, entitySettingsMap, errors, customFieldSettings])

  return {
    checkNonRequiredErrors,
  }
}
